// @ts-nocheck
import React, { useEffect } from 'react';
import useSelector from 'modules/default-selector';
import { UsersClaims, findAndParseClaim } from 'shared-types';

export const ChatContext = React.createContext<{ handleOpenChat: () => void }>({
  handleOpenChat: () => {},
});

export const ChatProvider: React.FC = ({ children }) => {
  const email = useSelector(state => state.user.credor?.email);
  const userId = useSelector(state => state.user.credor?.id_credor);
  const creditorId = useSelector(state => state.user.credor?.id_credor_externo);
  const userClaims = useSelector(state => state.user.claims) ?? [];
  const [openChat, setOpenChat] = React.useState(false);
  const splitcReferralIsDisabled = findAndParseClaim<UsersClaims.DISABLE_SPLITC_REFERRAL>(
    UsersClaims.DISABLE_SPLITC_REFERRAL,
    userClaims,
  );

  const name = useSelector(state => state.user.credor?.nome_credor);
  const office = useSelector(state => state.user.escritorio);
  const isTeddyDomain = window.location.hostname === 'comissoes.teddy360.com.br';

  const shouldShow = (): boolean => {
    if (isTeddyDomain) return false;
    if (splitcReferralIsDisabled.success) {
      return !splitcReferralIsDisabled.data;
    }
    return true;
  };

  const isAllowedToShow = shouldShow();

  window.fcWidgetMessengerConfig = {
    siteId: 'Comissões',
  };

  useEffect(() => {
    if (!isAllowedToShow) return;
    const el = document.querySelector('script[fc-chat="fc-chat"]');
    if (el) return;
    const fs = document.createElement('script');
    fs.setAttribute('fc-chat', 'fc-chat');
    fs.src = '//fw-cdn.com/2125965/2834505.js';
    fs.async = true;
    fs.defer = true;
    fs.id = 'fc_chat';
    if (openChat) {
      fs.setAttribute('chat', 'true');
      document.body.appendChild(fs);
    }
  }, [isAllowedToShow, openChat]);

  useEffect(() => {
    const element = document.getElementById('fc_frame');
    if (!element) return;
    element.style.display = openChat ? 'none' : 'block';
  }, [creditorId, email, isAllowedToShow, name, office, openChat, userId]);

  const handleOpenChat = () => {
    setOpenChat(!openChat);
    if (!name && !office && !email && !userId && !isAllowedToShow && !openChat) return;
    const hasLoadedWidget = Boolean(window.fcWidget);
    if (hasLoadedWidget) {
      window.fcSettings = {
        onInit() {
          window.fcWidget.setExternalId(String(userId));
          window.fcWidget.user.setFirstName(name);
          window.fcWidget.user.setEmail(email);
          window.fcWidget.user.setProperties({
            open: openChat,
            creditorId,
            office: office?.nome_escritorio,
            officeId: office?.id_escritorio,
          });
        },
      };
    }
  };

  return <ChatContext.Provider value={{ handleOpenChat }}>{children}</ChatContext.Provider>;
};

export const useChat = () => {
  const { handleOpenChat } = React.useContext(ChatContext);

  return { handleOpenChat };
};
